exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".translucid{transition:opacity 100ms linear;mix-blend-mode:difference;opacity:0.5}.translucid:hover{opacity:0.8}\n", ""]);
